import type { AutoGeneratorForFormModel } from "@/components/features/_model/types";

import * as Composition from "./composition";

/**
 *
 * @description currentInputModel と initInputModel を比較し、差分があれば ViewModel の isDirty を true にし、ViewModel を返す
 *
 * @param viewModel
 * @param currentInput
 * @param initInput
 *
 * @returns ViewModel
 *
 */
export const isDirtyMapper = <I, E, Q>(
	viewModel: AutoGeneratorForFormModel<I, E, Q>["ViewModel"],
	currentInput: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
	initInput?: AutoGeneratorForFormModel<I, E, Q>["InputModel"],
): AutoGeneratorForFormModel<I, E, Q>["ViewModel"] => {
	const isDirty = Composition.confirmIsDirty(currentInput, initInput);
	viewModel.isDirty = isDirty;

	return viewModel;
};
